"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadlineFigures = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const format_1 = require("./format");
const Headline = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  background: ${theme_1.theme.colors.grey(4)};
  border: 1px solid ${theme_1.theme.colors.grey(4)};
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: ${theme_1.theme.spacing(4)};

  @media (max-width: ${theme_1.breakpoints.mobile}px) {
    grid-template-columns: 1fr;
  }
`;
const Cell = styled_components_1.default.div `
  background: ${theme_1.theme.colors.white};
  padding: ${theme_1.theme.spacing(3)} ${theme_1.theme.spacing(3)};
`;
const Label = styled_components_1.default.div `
  ${theme_1.theme.fontLabelBold};
  ${theme_1.theme.fontSize(-1)};
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: ${theme_1.theme.colors.dimBlue};
`;
const Value = styled_components_1.default.div `
  ${theme_1.theme.fontTitle};
  ${theme_1.theme.fontSize(4)};
  letter-spacing: -0.02em;
  line-height: 1.1;
  margin: 6px 0 2px;
  color: ${(p) => p.$color};
`;
const Sub = styled_components_1.default.div `
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(0)};
  color: ${theme_1.theme.colors.dimBlue};
`;
const HeadlineFigures = ({ result }) => ((0, jsx_runtime_1.jsxs)(Headline, { children: [(0, jsx_runtime_1.jsxs)(Cell, { children: [(0, jsx_runtime_1.jsx)(Label, { children: "Compliance surplus generated" }), (0, jsx_runtime_1.jsx)(Value, { "$color": theme_1.theme.colors.green, children: (0, format_1.formatInt)(Math.max(result.surplus, 0)) }), (0, jsx_runtime_1.jsxs)(Sub, { children: ["tCO\u2082e \u00B7 ", (0, format_1.formatTwo)(result.tons > 0 ? result.surplus / result.tons : 0), " ", "t per tonne of biofuel"] })] }), (0, jsx_runtime_1.jsxs)(Cell, { children: [(0, jsx_runtime_1.jsx)(Label, { children: "Net result, pooling the surplus" }), (0, jsx_runtime_1.jsx)(Value, { "$color": result.poolNet >= 0 ? theme_1.theme.colors.blue : theme_1.theme.colors.red, children: (0, format_1.formatCompact)(result.poolNet) }), (0, jsx_runtime_1.jsxs)(Sub, { children: ["after the biofuel premium \u00B7 ", (0, format_1.formatCompact)(result.offsetNet), " offsetting your own penalty instead"] })] })] }));
exports.HeadlineFigures = HeadlineFigures;
